module.exports = __webpack_public_path__ + "static/img/RWA1264-G_1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/RWA1264-G_1.png
// module id = r1ZH
// module chunks = 0